import React from 'react';
import { BadgeCheck, Star } from 'lucide-react';

const CATEGORY_LABELS = {
  cbv: 'CBV',
  business_broker: 'BROKER',
  lender: 'LENDER',
  cepa_coach: 'ADVISOR',
  accountant: 'ACCOUNTANT',
  lawyer: 'LAWYER',
};

export default function FeaturedPartnerCard({ partner }) {
  const initials = (partner.name || '')
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const categoryLabel = CATEGORY_LABELS[partner.partner_category] || partner.partner_category?.toUpperCase();

  return (
    <a
      href={`/succeedo/partners/${partner.id}`}
      className="bg-card border border-border rounded-[12px] p-4 hover:border-[hsl(var(--succeedo-orange))]/30 transition-colors block"
    >
      <div className="flex items-center gap-3 mb-3">
        {partner.avatar_url ? (
          <img src={partner.avatar_url} alt={partner.name} className="w-10 h-10 rounded-full object-cover" />
        ) : (
          <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center text-foreground font-semibold text-sm">
            {initials}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1">
            <span className="text-[14px] font-medium text-foreground truncate">{partner.name}</span>
            {partner.verified && <BadgeCheck className="w-3 h-3 text-[hsl(var(--succeedo-orange))] flex-shrink-0" />}
          </div>
          {partner.org_name && (
            <div className="text-[12px] text-muted-foreground truncate">{partner.org_name}</div>
          )}
          <div className="text-[11px] text-muted-foreground/60 truncate">
            {(partner.geography_regions || []).join(', ')}
          </div>
        </div>
      </div>

      {/* Category badge */}
      {categoryLabel && (
        <div className="inline-flex items-center font-mono text-[10px] uppercase rounded-full px-2 py-0.5 mb-2"
             style={{ color: 'hsl(var(--succeedo-orange))', border: '1px solid hsl(var(--succeedo-orange) / 0.3)' }}>
          {categoryLabel}
        </div>
      )}

      {partner.rating > 0 && (
        <div className="flex items-center gap-1 mb-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <Star key={star} className={`w-3 h-3 ${star <= Math.floor(partner.rating) ? 'text-[hsl(var(--succeedo-orange))] fill-[hsl(var(--succeedo-orange))]' : 'text-muted-foreground/20'}`} />
          ))}
          <span className="font-mono text-[10px] text-muted-foreground ml-1">{partner.rating}</span>
        </div>
      )}

      {partner.bio && <p className="text-[12px] text-muted-foreground line-clamp-2">{partner.bio}</p>}
    </a>
  );
}
